import React, { useContext } from 'react';

// this is the equivalent to the createStore method of Redux
// https://redux.js.org/api/createstore

const MyContext = React.createContext();
export const useMyContext = () => useContext(MyContext);

export default MyContext;